import '../../style/App.css';
import { useState, useRef, useEffect } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import FileUpload from '../FileUpload.js';
import TextInput from '../TextInput.js';
import showcaseImg from "../../pics/icons/showcase.png"
import OptionButton from './OptionButton.js';
import ImageDropdown from './ImageDropdown.js';
import { useImages } from '../../../../../providers/ImagesProvider.js';

const SharePvImagePopup = ({socket}) => {
    const [open, setOpen] = useState(false);

    const { 
        links, setLinks, 
        avatars, setAvatars, 
        backgrounds, setBackgrounds, 
        showcases, setShowcases,
        showCaseGlow, setShowCaseGlow,
        playerViewSharedImage, setPlayerViewSharedImage
    } = useImages();

    const dialogRef = useRef(null);

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dialogRef.current && !dialogRef.current.contains(event.target)) {
                handleClose();
            }
        };

        if(open) {  
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, [open, socket]);

    const handleClick = (imageObj) => {
        socket.emit("sendPvShowcase", {imageGuid: imageObj.imageGuid})
        setPlayerViewSharedImage({type: "image", src: imageObj.image})
        setShowCaseGlow(true)
    };

    const stopSharingImage = () => {
        setPlayerViewSharedImage(null)
        socket.emit('pvShowcaseKill')
        setShowCaseGlow(false)
    }

    return (
        <>
            <OptionButton src={showcaseImg} message={`Share Image to Pv`} onClickFunction={() => setOpen(true)} 
                imgStyle={{
                    outline: showCaseGlow ? '1px solid rgba(250, 130, 125)' : '',
                    animation: showCaseGlow ? 'defaultBackgroundShadowPulse 2.5s ease-in-out infinite' : ''
                }} 
            />
            <Dialog open={open} onClose={handleClose} ref={dialogRef} >
                <div className='avatarUploadHeader'>
                    <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center', fontSize: '20px'}}>
                        <b>Shar{playerViewSharedImage ? 'ing' : 'e'} Image to PlayerView</b>
                    </div>
                    
                    {playerViewSharedImage &&
                        <div className='sharedPvImageContainer'>
                            <div style={{width: '180px', height: '180px'}}>
                                <img style={{width: '180px', height: '180px', outline: '2px solid black', marginTop: '5px'}} src={playerViewSharedImage.src} alt={"background"}/>
                            </div>
                            <OptionButton src={showcaseImg} imgStyle={{outline: "2px solid red"}} message={`Stop Sharing`} onClickFunction={stopSharingImage} />
                        </div>
                    }
                    <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center'}}>
                        <FileUpload setUploadedFiles={setShowcases} storageKey={"showcase"} socket={socket} label={'Showcase Image'}/>
                        <TextInput setUploadedLinks={setShowcases} storageKey={"showcase"} label={'Youtube Showcase'} socket={socket}/>
                    </div>
                    <hr className='lineSeperator' style={{margin: '10px 0 10px 0'}}/>
                </div>

                <DialogContent style={{padding: '5px'}}>
                    <ImageDropdown title='Showcases' uploadedType={'showcase'} uploadedFiles={showcases} setUploadedFiles={setShowcases} handleClick={handleClick} autoOpen={true} socket={socket}/>
                    <ImageDropdown title='Youtube Links' uploadedType={'link'} uploadedFiles={links} setUploadedFiles={setLinks} handleClick={handleClick} socket={socket}/>
                    <ImageDropdown title='Backgrounds' uploadedType={'background'} uploadedFiles={backgrounds} setUploadedFiles={setBackgrounds} handleClick={handleClick} socket={socket}/>
                    <ImageDropdown title='Avatars' uploadedType={'avatar'} uploadedFiles={avatars} setUploadedFiles={setAvatars} handleClick={handleClick} socket={socket}/>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default SharePvImagePopup;